/**
 * CompanySelectCard 컴포넌트 - 세금계산서 발급 시 회사 선택용 카드
 * (company-list/CompanyCard.tsx에서 통합됨)
 */

import { ChevronRight, Plus } from 'lucide-react';
import type { Company, CompanyListTranslations } from './types';

interface CompanySelectCardProps {
  company: Company;
  t: CompanyListTranslations;
  onSelect: (company: Company) => void;
}

export function CompanySelectCard({ company, t, onSelect }: CompanySelectCardProps) {
  return (
    <button
      onClick={() => onSelect(company)}
      className="w-full p-4 rounded-xl border-2 border-border hover:border-primary hover:bg-primary/5 transition-all text-left"
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="font-medium text-foreground">{company.name}</h3>
            {company.isDefault && (
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full">
                {t.defaultCompany}
              </span>
            )}
          </div>
          <p className="text-sm text-muted-foreground font-mono">RFC: {company.rfc}</p>
          <p className="text-sm text-muted-foreground mt-1">{company.address}</p>
          {company.email && (
            <p className="text-sm text-muted-foreground">{company.email}</p>
          )}
        </div>
        <ChevronRight className="w-5 h-5 text-muted-foreground flex-shrink-0 mt-1" />
      </div>
    </button>
  );
}

interface AddCompanyButtonProps {
  label: string;
  onClick: () => void;
}

export function AddCompanyButton({ label, onClick }: AddCompanyButtonProps) {
  return (
    <button
      onClick={onClick}
      className="w-full p-4 border-2 border-dashed border-border rounded-xl flex items-center justify-center gap-2 text-muted-foreground hover:border-primary hover:text-primary transition-all"
    >
      <Plus className="w-5 h-5" />
      <span className="font-medium">{label}</span>
    </button>
  );
}
